import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
import ImageUploader from 'react-images-upload';
import { Formik, useFormik } from "formik";
import { toast } from 'react-toastify';



import RecursiveContainer from "./RecursiveContainer";
import { useTranslation } from "react-i18next";

const FormikDialog = forwardRef((props, ref) => {
  const {
    classes,
    headline,
    onFormSubmit,
    prefix,
    validationSchema,
    fieldList,
    selectedData,
    uploadImage,
    previewProps,
    previewComplements,
    childrenPos,
    children,
  } = props;

  const [isSended, setIsSended] = useState(false);

  const { t } = useTranslation();

  useImperativeHandle(ref, () => ({
    updateValueFromParent(name, value) {
      try {
        formik.setFieldValue(name, value);
      } catch (err) { }
    }
  }))

  const formik = useFormik({
    initialValues: selectedData,
    enableReinitialize: true,
    onSubmit: values => {
      onFormSubmit(values);
      setIsSended(false);
    },
    validationSchema: validationSchema
  }, [selectedData]);

  useEffect(() => {
    if (selectedData) {
      fieldList?.map(x => {
        formik.setFieldValue(x.dbname, selectedData[x.dbname]);
        return null;
      });
    }
  }, []);

  const sendedClicked = () => {
    if (Object.keys(formik.values).length === 0) {
      formik.validateForm();
      setIsSended(true);
    } else if (!formik.isValid) {
      toast(t('SENDED_WITH_ERRORS'));

      setIsSended(true);
    } else {
      formik.submitForm();
    }
  };

  const handleImage = (pictureFiles, pictureDataURLs) => {
    formik.setFieldValue('pictures', pictureFiles);
  };

  const getImageUri = () => {
    if (previewComplements)
      return `https://zq-images.s3.amazonaws.com/${previewComplements}`;
    return `https://zq-images.s3.amazonaws.com/${previewProps.storeId}/${previewProps.productId}.jpg`;

  }

  return (
    <div
      className="modal fade"
      id={`${prefix}_modal_form`}
      data-bs-backdrop="static"
      tabIndex="-1"
      aria-hidden="true"
    >
      <div className="modal-dialog">
        <Formik>
          <form className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="backDropModalTitle">Nuevo {prefix}</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              {
                childrenPos && ['startForm'].includes(childrenPos) && (children)
              }
              <RecursiveContainer
                config={fieldList}
                formik={formik}
                prefix={prefix}
                classes={classes}
                sended={isSended}
              />

              {
                childrenPos && ['endForm'].includes(childrenPos) && (children)
              }
              {
                uploadImage &&
                <ImageUploader
                  withIcon={true}
                  buttonText='Choose images'
                  onChange={handleImage}
                  imgExtension={['.jpg', '.gif', '.png', '.gif', '.jpeg', '.webp']}
                  maxFileSize={5242880}
                  singleImage={true}
                  withPreview={true}
                />
              }
              {
                uploadImage &&

                <div className={classes.imagePreviews}>
                  <img src={getImageUri()} style={previewProps.style || { width: 150, alignSelf: "center" }} alt="" />
                </div>
              }
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-outline-secondary" data-bs-dismiss="modal">
                Close
              </button>
              <button type="button" className="btn btn-primary" onClick={sendedClicked}>Save</button>
            </div>
          </form>
        </Formik>
      </div>

    </div>
  );
});

export default FormikDialog;
